import React from 'react'
import WorkFlowsData from '../components/workflow/WorkflowsData';
import { useLocation } from "react-router-dom";

function ManageWorkflow() {
  const location = useLocation();
  const path = location.pathname?.toLocaleLowerCase() || '';

  return (
    <div style={{ width: '100%', boxSizing: 'border-box', background: '#f4f3ef' }}>
      <WorkFlowsData PathName={path} />
    </div>
  )
}

export default ManageWorkflow;
